module.exports = __webpack_public_path__ + "img/wechat_bg@2x.dcfb239f.png";